import { render } from "./ContenuThirdPanelItem.vue?vue&type=template&id=6440d3ee"
import script from "./ContenuThirdPanelItem.vue?vue&type=script&lang=js"
export * from "./ContenuThirdPanelItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__